import { atom } from 'recoil';

// 사이드 박스 모달
export const SideMenuBoxRecoil = atom<boolean>({
  key: 'SideMenuBoxRecoil',
  default: false,
});

// 에러 모달
export const errorModalTextRecoil = atom<string>({
  key: 'errorModalTextRecoil',
  default: '',
});

// 완료 모달
export const completeModalRecoil = atom<boolean>({
  key: 'completeModalRecoil',
  default: false,
});

// 수정 모달
export const modifyModalRecoil = atom<boolean>({
  key: 'modifyModalRecoil',
  default: false,
});

// 삭제 모달
export const deleteModalRecoil = atom<boolean>({
  key: 'deleteModalRecoil',
  default: false,
});

// 맵 로딩
export const MapLoadingRecoil = atom<boolean>({
  key: 'MapLoadingRecoil',
  default: false,
});

// 로딩
export const LoadingRecoil = atom<boolean>({
  key: 'LoadingRecoil',
  default: false,
});

// 이미지 자세히 보기 모달
export const imgDetailModalRecoil = atom<boolean>({
  key: 'imgDetailModalRecoil',
  default: false,
});

// 시설물 등록 모달
export const facilitiesAddModalRecoil = atom<boolean>({
  key: 'facilitiesAddModalRecoil',
  default: false,
});

// 시설물 수정 모달
export const facilitiesModifyModalRecoil = atom<boolean>({
  key: 'facilitiesModifyModalRecoil',
  default: false,
});

// 시설물 검색 모달
export const facilitiesSearchModalRecoil = atom<boolean>({
  key: 'facilitiesSearchModalRecoil',
  default: false,
});

// 점검일지 등록 모달
export const inspectionLogAddModalRecoil = atom<boolean>({
  key: 'inspectionLogAddModalRecoil',
  default: false,
});

// 점검일지 수정 모달
export const inspectionLogModifyModalRecoil = atom<boolean>({
  key: 'inspectionLogModifyModalRecoil',
  default: false,
});

// 모델 등록 모달
export const modelAddModalRecoil = atom<boolean>({
  key: 'modelAddModalRecoil',
  default: false,
});

// 모델 수정 모달
export const modelModifyModalRecoil = atom<boolean>({
  key: 'modelModifyModalRecoil',
  default: false,
});

// 모델 레포트 모달
export const modelReportModalRecoil = atom<boolean>({
  key: 'modelReportModalRecoil',
  default: false,
});

// 디바이스 등록 모달
export const deviceAddModalRecoil = atom<boolean>({
  key: 'deviceAddModalRecoil',
  default: false,
});

// 디바이스 추가 모달
export const devicePlusModalRecoil = atom<boolean>({
  key: 'devicePlusModalRecoil',
  default: false,
});

// 디바이스 수정 모달
export const deviceModifyModalRecoil = atom<boolean>({
  key: 'deviceModifyModalRecoil',
  default: false,
});

// 디바이스 명령어 등록 모달
export const deviceCommandAddModalRecoil = atom<boolean>({
  key: 'deviceCommandModalAddRecoil',
  default: false,
});

// 디바이스 명령어 수정 모달
export const deviceCommandModifyModalRecoil = atom<boolean>({
  key: 'deviceCommandModalModifyRecoil',
  default: false,
});

// 알림 교정값 수정 모달
export const alarmCorrectionModifyModalRecoil = atom<boolean>({
  key: 'alarmCorrectionModifyModalRecoil',
  default: false,
});

// 이벤트 등록 모달
export const eventAddModalRecoil = atom<boolean>({
  key: 'eventAddModalRecoil',
  default: false,
});

// 이벤트 수정 모달
export const eventModifyModalRecoil = atom<boolean>({
  key: 'eventModifyModalRecoil',
  default: false,
});

// 이벤트 상세 모달
export const eventDetailModalRecoil = atom<boolean>({
  key: 'eventDetailModalRecoil',
  default: false,
});

// 비밀번호 수정 모달
export const passwordModifyModalRecoil = atom<boolean>({
  key: 'passwordModifyModalRecoil',
  default: false,
});

// 회원 등록 모달
export const userAddModalRecoil = atom<boolean>({
  key: 'userAddModalRecoil',
  default: false,
});

// 회원 수정 모달
export const userModifyModalRecoil = atom<boolean>({
  key: 'userModifyModalRecoil',
  default: false,
});

// 회원 구분 등록 모달
export const userDivisionAddModalRecoil = atom<boolean>({
  key: 'userDivisionAddModalRecoil',
  default: false,
});

// 회원 구분 수정 모달
export const userDivisionModifyModalRecoil = atom<boolean>({
  key: 'userDivisionModifyModalRecoil',
  default: false,
});

// 총판 등록 모달
export const distributorAddModalRecoil = atom<boolean>({
  key: 'distributorAddModalRecoil',
  default: false,
});

// 총판 수정 모달
export const distributorModifyModalRecoil = atom<boolean>({
  key: 'distributorModifyModalRecoil',
  default: false,
});

// 사이트 등록 모달
export const siteAddModalRecoil = atom<boolean>({
  key: 'siteAddModalRecoil',
  default: false,
});

// 사이트 수정 모달
export const siteModifyModalRecoil = atom<boolean>({
  key: 'siteModifyModalRecoil',
  default: false,
});

// 공지사항 등록 모달
export const noticeAddModalRecoil = atom<boolean>({
  key: 'noticeAddModalRecoil',
  default: false,
});

// 공지사항 수정 모달
export const noticeModifyModalRecoil = atom<boolean>({
  key: 'noticeModifyModalRecoil',
  default: false,
});

// 주소 모달
export const addressModalRecoil = atom<boolean>({
  key: 'addressModalRecoil',
  default: false,
});

// 좌표 모달
export const coordinateModalRecoil = atom<boolean>({
  key: 'coordinateModalRecoil',
  default: false,
});
